<template>
    <div id="dashboard">
        <nav class="navbar navbar-expand-lg navbar-light dashboard__navbar">
            <div class="row mx-auto w-100">
                <div class="col-sm-6 p-0 order-1 order-sm-0 my-auto">
                    <div class="dashboard__welcome mt-2 mt-sm-0">
                        Welcome, <b>{{ user.commonName }}!</b>
                    </div>
                </div>
                <div class="col-sm-6 p-0 order-0 order-sm-1 text-sm-right">
                    <button type="button" id="sidebarCollapse" class="btn btn-default">
                        <i class="far fa-bars"></i>
                        <span> Menu</span>
                    </button>
                </div>
            </div>
        </nav>
        <div id="dashboard__content">
            <div v-if="mode==='management'" class="dashboard__management">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <admin-management :files="preferences.exports"></admin-management>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="dashboard__config">
                <div v-if="!preferences" class="alert alert-warning">
                    <i class="far fa-info"></i> The Opt-Out form preferences could not be
                    retrieved!
                    <b>Please contact your system administrator.</b>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <h3 class="dashboard__title">Admin Dashboard</h3>
                                <admin-preferences :preferences="preferences" @getPreferences="getPreferences">
                                </admin-preferences>
                                <hr>
                                <admin-exports :files="preferences.exports"></admin-exports>
                                <hr>
                                <admin-reports :files="preferences.exports"></admin-reports>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminExports from './Exports';
import AdminManagement from './Management';
import AdminPreferences from './Preferences';
import AdminReports from './Reports';

export default {
    name: 'admin-dashboard',
    components: {
        AdminPreferences,
        AdminExports,
        AdminManagement,
        AdminReports
    },
    props: {
        mode: {
            required: true,
        },
        preferences: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    },
    methods: {
        getPreferences() {
            // Retrieve admin preferences
            this.$emit('getPreferences');
        }
    }
}
</script>

<style scoped>
/* Card */
.card {
    border-radius: 6px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .14);
}

/* Dashboard */
.dashboard {
    display: flex;
    width: 100%;
}

.dashboard__title {
    color: #272c33;
    line-height: 40px;
}

#dashboard__content {
    margin-bottom: 2rem;
    margin-top: 2.75rem;
}

.dashboard__navbar {
    background: #ffffff;
    -webkit-box-shadow: 1px 0 5px rgba(0, 0, 0, 0.1);
    box-shadow: 1px 0 5px rgba(0, 0, 0, 0.1);
}

.dashboard__welcome {
    color: #009efb;
    font-size: 1rem;
    font-weight: 500;
    word-break: break-all;
}
</style>